import useQueryApiClient from '../../../utils/useQueryApiClient';
import { Flex, Form, message } from 'antd';
import { useIntl } from 'react-intl';
import { LoginStyleContainer } from './LoginStyleContainer';
import { Input, Button } from '../../../ui';
import { StyledEmailConfirmContainer } from './style';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import PublicRoute from 'enums/publicRoutes';

export const EmailConfirm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const intl = useIntl();
  const { logout } = useAuth();

  const { appendData, isLoading } = useQueryApiClient({
    request: {
      url: 'api/v2/send-confirm-email',
      method: 'POST',
    },
    onSuccess: () => {
      navigate(`${PublicRoute.CONFIRMATION}?email=${form.getFieldValue('email')}`);
    },
    onError: (e) => {
      if (e.code === 422) {
        message.error(
          intl.formatMessage({
            id: e.error,
          })
        );
      }
    },
  });

  return (
    <LoginStyleContainer>
      <StyledEmailConfirmContainer>
        <Form form={form} onFinish={appendData} layout={'vertical'}>
          <Flex gap={20} wrap>
            <Input
              label={intl.formatMessage({ id: 'general.email' })}
              size={'large'}
              required
              name={'email'}
              validations={['required', 'email']}
            />
            <Input
              size={'large'}
              name={'phone'}
              label={intl.formatMessage({ id: 'general.phone' })}
            />
          </Flex>
          <div className="button-list">
            <Button
              label={intl.formatMessage({ id: 'register.send_email' })}
              size="large"
              htmlType="submit"
              loading={isLoading}
            />
            <Button
              type={'text'}
              label={intl.formatMessage({ id: 'general.cancel' })}
              size="large"
              onClick={() => logout()}
            />
          </div>
        </Form>
      </StyledEmailConfirmContainer>
    </LoginStyleContainer>
  );
};
